<tyl-kendo-pdf-export [keepTogether]="" [scale]="scalePDF" class="tylKendoPdf">
  <div class="flex-header">
    <student-header [showYearSelector]="true" [disableYearSelect]="true" [pageTitle]="'Calendar'"></student-header>
  </div>
  <app-calendar-header style="display: flex; width: 100%; background: white; z-index: 999; align-items: center; justify-content: space-between; padding-right: 20px; padding-left: 20px"
    class="print-override-position" [(view)]="view" [(viewDate)]="viewDate">
  </app-calendar-header>
  <div class="flex-content">

    <!--Template for the custom Month View-->
    <ng-template #customMonthCellTemplate let-day="day" let-locale="locale">
      <div [ngClass]="checkForClasses(day)" style="display: flex; height: 100%">
        <div style="display: flex; flex-direction: column; flex: 1;">
          <div style="display: flex; flex-direction: row">
            <span class="cal-month-day" style="float: none;">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
          </div>
          <div style="padding-left: 5px;">
            <div *ngFor="let event of day.events | districtEvent">
              <div style="display: flex; flex-direction: row">
                <div>
                  <span style="padding-left: 2px;padding-right: 2px;font-size: 12pt;">&#8226;</span>
                </div>
                <div>
                  <div style="display: flex; flex-direction: row; padding-left: 5px;">{{event.title}}</div>
                  <div style="display: flex; flex-direction: row; color: #757575; padding-left: 5px; font-size: 10pt; margin-top: -5px">{{getTimeString(event)}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="cal-month-bottom" style="display: flex; flex-direction: row; justify-content: flex-end">
            <img *ngIf="checkAssignmentEvents(day)" style="width: 15px;" src="./assets/images/menumyclasses.png" />
            <img *ngIf="checkAttendanceEvents(day)" style="width: 34px; position: relative;top: 10px;" src="./assets/images/icons/checkbox 48.png" />
            <img *ngIf="checkDisciplineEvents(day)" style="width: 20px; position: relative;top: 1px; left: -3px;" src="./assets/images/gavel icon.png" />
          </div>
        </div>
      </div>
    </ng-template>
    <!--Template for the custom Day View-->
    <ng-template #customDayEventTemplate let-dayEvent="dayEvent" let-locale="locale">
      <div (click)="eventClicked(dayEvent)" [ngClass]="setEventColor(dayEvent)" [ngStyle]="{'height': dayEvent.height - 5 + 'px'}"
        style="display: flex; flex-direction: column; border-left-width: 5px; border-left-style: solid; padding-left: 10px">
        <!-- Schedule Event -->
        <div *ngIf="dayEvent.event.meta.eventType == 'dailyScheduleEvent'" style="height: 100%; display: flex; flex-direction: column;">
          <div class="flex-child" style="opacity: .8; font-size: 10px;" [ngClass]="setFontSize(dayEvent.event, 'time')">{{dayEvent.event.start| date: 'shortTime'}} -
            {{dayEvent.event.end| date: 'shortTime'}}</div>
          <div class="flex-child" [ngClass]="setFontSize(dayEvent.event, 'title')">{{dayEvent.event.title}}</div>
          <div style="display: flex; flex-direction: column; flex: 1; justify-content: flex-end">
            <div style="display: flex; flex-direction: row; justify-content: flex-end;">
              <img *ngIf="dayEvent.event.meta.event.Assignments.length > 0" style="height: 15px; margin-top: 5px; margin-right: 5px;"
                src="./assets/images/menumyclasses.png" alt="" />
              <img *ngIf="checkAttendance(dayEvent)" style="height: 34px;margin-top: -4px;margin-right: -6px;" src="./assets/images/icons/checkbox 48.png"
                alt="" />
            </div>
          </div>
        </div>
        <!-- District Event -->
        <div [ngClass]="allDayEvent(dayEvent)" *ngIf="dayEvent.event.meta.eventType == 'districtEvent'">
          <div *ngIf="eventHasTimes(dayEvent)" style="opacity: .8; font-size: 10px; padding-right: 10px; white-space: nowrap;">
            {{getTimeString(dayEvent.event)}}
          </div>
          <div class="flex-child">
            {{dayEvent.event.title}}
          </div>
        </div>
        <!-- Discipline Event -->
        <div *ngIf="dayEvent.event.meta.eventType == 'disciplineEvent'" style="display: flex; flex-direction: row; align-items: center; flex: 1; height: 100%">
          <div class="flex-child">
            {{dayEvent.event.title}}
          </div>
        </div>
      </div>
    </ng-template>
    <!--Template for the custom Week View-->
    <ng-template #customWeekEventTemplate let-weekEvent="weekEvent" let-locale="locale">
      <div (click)="eventClicked(weekEvent)" [ngClass]="setEventColor(weekEvent)" [ngStyle]="{'height': weekEvent.height - 2 + 'px'}"
        style="border-left-width: 5px; border-left-style: solid; padding-left: 5px; margin-right: 5px">
        <div style="height: 100%; flex: 1">
          <!-- Schedule Event -->
          <div *ngIf="weekEvent.event.meta.eventType == 'dailyScheduleEvent'" style="display: flex;flex-direction: column; flex: 1; height: 100%">
            <div class="flex-child" style="opacity: .8; font-size: 10px" [ngClass]="setFontSize(weekEvent.event, 'time')">{{weekEvent.event.start| date: 'shortTime'}} -
              {{weekEvent.event.end| date: 'shortTime'}}</div>
            <div class="flex-child" [ngClass]="setFontSize(weekEvent.event, 'title')">{{weekEvent.event.title}}</div>
            <div style="display: flex; flex-direction: column; flex: 1; justify-content: flex-end">
              <div style="display: flex; flex-direction: row; justify-content: flex-end;">
                <img *ngIf="weekEvent.event.meta.event.Assignments.length > 0" style="height: 15px; margin-top: 5px; margin-right: 5px;"
                  src="./assets/images/menumyclasses.png" alt="" />
                <img *ngIf="checkAttendance(weekEvent)" style="height: 34px;margin-top: -4px;margin-right: -6px;" src="./assets/images/icons/checkbox 48.png"
                  alt="" />
              </div>
            </div>
          </div>
          <!-- District Event -->
          <div [ngClass]="allDayEvent(weekEvent)" *ngIf="weekEvent.event.meta.eventType == 'districtEvent'">
            <div class="flex-child" *ngIf="eventHasTimes(weekEvent)" style="opacity: .8; font-size: 10px; padding-right: 10px; white-space: nowrap;">
              {{getTimeString(weekEvent.event)}}
            </div>
            <div class="flex-child">
              {{weekEvent.event.title}}
            </div>
          </div>
          <!-- Discipline Event -->
          <div *ngIf="weekEvent.event.meta.eventType == 'disciplineEvent'" style="display: flex; flex-direction: row; align-items: center; flex: 1; height: 100%">
            <div class="flex-child">
              {{weekEvent.event.title}}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

      <ng-template #hourSegmentTemplateDay let-segment="segment" let-locale="locale" let-segmentHeight="segmentHeight">
          <div class="cal-hour-segment"
              [style.height.px]="segmentHeight"
              [class.cal-hour-start]="segment.isStart"
              [class.cal-after-hour-start]="!segment.isStart"
              [ngClass]="checkDayForClasses(segment, false)">
              <div class="cal-time">
                  {{ segment.date | calendarDate: 'dayViewHour':locale }}
              </div>
          </div>
      </ng-template>

      <ng-template #hourSegmentTemplateWeek let-segment="segment" let-locale="locale" let-segmentHeight="segmentHeight" let-isTimeLabel="isTimeLabel">
          <div class="cal-hour-segment"
              [style.height.px]="segmentHeight"
              [class.cal-hour-start]="segment.isStart"
              [class.cal-after-hour-start]="!segment.isStart"
              [ngClass]="checkDayForClasses(segment, isTimeLabel)">
              <div class="cal-time" *ngIf="isTimeLabel">
                  {{ segment.date | calendarDate: 'weekViewHour':locale }}
              </div>
          </div>
      </ng-template>

    <div [ngSwitch]="view" style="padding-top: 40px">
      <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate" [events]="events" [refresh]="refresh" [hourSegmentTemplate]="hourSegmentTemplateDay"
        [dayStartHour]="7" [hourSegmentHeight]="25" [eventWidth]="500" [eventTemplate]="customDayEventTemplate"
        [hourSegments]="4">
      </mwl-calendar-day-view>
      <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate" [refresh]="refresh" [dayStartHour]="7" [hourSegmentTemplate]="hourSegmentTemplateWeek"
        [hourSegments]="4" [hourSegmentHeight]="25" [eventTemplate]="customWeekEventTemplate" (dayHeaderClicked)="viewDate = $event.day.date; view = 'day'"
        [events]="events">
      </mwl-calendar-week-view>
      <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [refresh]="refresh" [cellTemplate]="customMonthCellTemplate"
        [events]="events" (dayClicked)="viewDate = $event.day.date; view = 'day'">
      </mwl-calendar-month-view>
    </div>

  </div>
</tyl-kendo-pdf-export>